import { Add, ChevronRight, Edit } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";

import { HierarchyItem } from "#/features/Hierarchy/components/HierarchyItem";
import { CustomButton } from "@/common/components";

import { HierarchyModelBase, HierarchyModelView } from "../types";

export const HierarchyContainer = ({
  isLoading,
  top,
  onClick,
  onEdit,
  editEnabled,
}: {
  isLoading?: boolean;
  top: HierarchyModelView;
  onClick?: (view: HierarchyModelView, item: HierarchyModelBase) => void;
  onEdit?: (
    event: React.MouseEvent<HTMLButtonElement>,
    view: HierarchyModelView,
    item?: HierarchyModelBase,
  ) => void;
  editEnabled?: boolean;
}) => {
  const renderColumn: (column: HierarchyModelView) => JSX.Element = (
    column: HierarchyModelView,
  ) => (
    <>
      <Box className={"ContainerColumn"}>
        <Box className={"ContainerItem title"}>
          <Typography variant={"h6"}>{column.name}</Typography>

          <CustomButton
            className={"ContainerItem edit"}
            variant="contained"
            iconOnly
            trackingLabel={null}
            onClick={(event) => onEdit?.(event, column)}
            startIcon={<Add />}
          />
        </Box>

        <div>&nbsp;</div>

        <Box className={"ContainerChildren"}>
          {column.model.children?.map((item) => (
            <HierarchyItem
              key={item.id}
              selected={column.selectedId === item.id}
              onClick={() => onClick?.(column, item)}
              item={item}
              edit={
                editEnabled ? (
                  <CustomButton
                    trackingLabel={null}
                    className={"edit"}
                    startIcon={<Edit />}
                    iconOnly
                    onClick={(event) => onEdit?.(event, column, item)}
                    sx={{ p: 0, w: "20px" }}
                    variant="outlined"
                  />
                ) : (
                  <></>
                )
              }
              postfix={column.hasNext ? <ChevronRight /> : <></>}
            />
          ))}

          {!(column.model.children?.length ?? 0) && (
            <>
              {isLoading ? (
                <CircularProgress size={20} color="secondary" data-testid="loading-indicator" />
              ) : (
                <Typography m={"10px"}>No entities defined.</Typography>
              )}
            </>
          )}
        </Box>
      </Box>
      {column.next && renderColumn(column.next)}
    </>
  );

  const renderColumns = () => <Box className={"ContainerView"}>{renderColumn(top)}</Box>;

  return renderColumns();
};
